import { render, staticRenderFns } from "./IpoInformation.vue?vue&type=template&id=2dcdd5bc&scoped=true"
import script from "./IpoInformation.vue?vue&type=script&lang=js"
export * from "./IpoInformation.vue?vue&type=script&lang=js"
import style0 from "./IpoInformation.vue?vue&type=style&index=0&id=2dcdd5bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcdd5bc",
  null
  
)

export default component.exports